import { render, staticRenderFns } from "./ShibouDoukishoConfirmCard.vue?vue&type=template&id=5133055c&scoped=true"
import script from "./ShibouDoukishoConfirmCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShibouDoukishoConfirmCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ShibouDoukishoConfirmCard.vue?vue&type=style&index=0&id=5133055c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5133055c",
  null
  
)

export default component.exports